import { browserHistory } from 'react-router';

import { signOut } from '@lib/actions';
import storage from '@lib/services/storageService';

// eslint-disable-next-line require-yield
export default function* sagaSignOut(action: ReturnType<typeof signOut>): any {
  storage.removeAuth();

  // Notify about the signOut in case the app is embeded on customer's site
  if (window.parent) window.parent.postMessage({ caller: 'lh:patient-app', action: 'signOut' }, '*');

  // TODO Invalidate Relay's store to ensure we don't show cached data during next session
  // invalidateStore(environment);

  if (!/^\/login|^\/lumabot/i.test(window.location.pathname)) {
    let path = action.payload.path || '/login';
    if (action.payload.includeReturnUrl) {
      // Add the returnUrl URL parameter to be redirected back to last path after login
      const returnUrl = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
      path += `?returnUrl=${returnUrl}`;
    }
    browserHistory.push(path);
  }
}
